var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"remoteIconsWrapper"},[(_vm.audioMuted)?_c('i',{staticClass:"icon fas fa-microphone-slash"}):_vm._e(),(_vm.videoMuted)?_c('i',{staticClass:"icon fas fa-video-slash"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }